/******************************************************************************
   NAME:       TSVH
   AUTHOR:     Duynh
******************************************************************************/
import { Injectable } from '@angular/core';
import { ApiService, UserService } from 'app/services';
import { environment } from 'environments/environment';

@Injectable()
export class TSPTService {
  APIURL = "api/Permission";
  constructor(private api: ApiService, private user: UserService) {

  }
  getTSPT_DANHSACH(mataikhoan, danhmucid, ngay, gio, locdulieu, lockhachhang, sotrang, sodong, ip, loaipha) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_TSPT" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_ngay: ngay,
        v_gio: gio,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_ip: ip,
        v_loaipha: loaipha,
        v_locdulieu: locdulieu,
        v_lockhachhang: lockhachhang,
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }

  getTSPT_EXCEL(data, mataikhoan, title, danhmucid, ngay, gio, locdulieu, lockhachhang, sotrang, sodong, ip, filename, header) {
    let cols = [];
    if (locdulieu == 0) {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
        { "name": "starttime", "label": "Thời gian hệ thống", "horizontalalignment": "center" },
        { "name": "endtime", "label": "Thời gian công tơ", "horizontalalignment": "center" },
        { "name": "importkw", "label": "P tổng giao (KW)", "horizontalalignment": "right" },
        { "name": "exportkw", "label": "P tổng nhận (KW)", "horizontalalignment": "right" },
        { "name": "c1", "label": "Q tổng giao (KVAR)", "horizontalalignment": "right" },
        { "name": "c2", "label": "P tổng nhận (KVAR)", "horizontalalignment": "right" }

      ]
    }
    else {
      cols = [
        { "name": "stt", "label": "STT", "horizontalalignment": "center" },
        { "name": "imei", "label": "IMEI", "horizontalalignment": "left" },
        { "name": "socongto", "label": "Số công tơ", "horizontalalignment": "left" },
        { "name": "loaicongto", "label": "Loại công tơ", "horizontalalignment": "left" },
        { "name": "madiemdo", "label": "Mã điểm đo", "horizontalalignment": "left" },
        { "name": "tenkhachhang", "label": "Tên khách hàng", "horizontalalignment": "left" },
        { "name": "matram", "label": "Mã trạm", "horizontalalignment": "left" },
        { "name": "macot", "label": "Mã cột", "horizontalalignment": "left" },
        { "name": "masoghi", "label": "Mã sổ ghi", "horizontalalignment": "left" },
        { "name": "marepeater", "label": "Mã repeater", "horizontalalignment": "left" },

      ]
    }
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_TSPT" }),
      para: JSON.stringify({
        v_mataikhoan: mataikhoan,
        v_danhmucid: danhmucid,
        v_ngay: ngay,
        v_gio: gio,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_ip: ip,
        v_loaipha: 3,
        v_locdulieu: locdulieu,
        v_lockhachhang: lockhachhang,
      }),
      title: title,
      header: header,
      filename: filename,
      sheets: "THÔNG SỐ PHỤ TẢI",
      columns: cols,
      data: ""
    };


    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  getTSPT_KHACHHANG(mataikhoan, meterid, socongto, tungay, denngay, sotrang, sodong, ip, loaipha) {
    let curUs = this.user.getCurrentUser();
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_TSPT_KH" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: sotrang,
        v_socongto: socongto,
        v_sodong: sodong,
        v_mataikhoan: mataikhoan,
        v_ip: ip,
      })
    };

    return this.api.Excute("api/ExcuteOracle", param);
  }

  getTSPT_EXCEL_KHACHHANG(meterid, socongto, mataikhoan, title: string, filename: string, tungay: string, denngay: string, dongcongto: string, header: string) {
    let cols = [
      { "name": "stt", "label": "STT", "horizontalalignment": "center" },
      { "name": "starttime", "label": "Thời gian bắt đầu", "horizontalalignment": "center" },
      { "name": "endtime", "label": "Thời gian kết thúc", "horizontalalignment": "center" },
      { "name": "importkw", "label": "P Giao (KWh)", "horizontalalignment": "right" },
      { "name": "exportkw", "label": "P Nhận (KWh)", "horizontalalignment": "right" },
      { "name": "c1", "label": "Q Giao (KVARh)", "horizontalalignment": "right" },
      { "name": "c2", "label": "Q Nhận (KVARh)", "horizontalalignment": "right" },
    ]

    if (dongcongto == "GELEX" || dongcongto == "LANDIS") {
      cols.push({ "name": "sl_pgiaotong", "label": "SL P giao tổng (KWh)", "horizontalalignment": "right" });
      cols.push({ "name": "sl_pnhantong", "label": "SL P nhận tổng (KWh)", "horizontalalignment": "right" });
      cols.push({ "name": "sl_qgiaotong", "label": "SL Q giao tổng (KVARh)", "horizontalalignment": "right" });
      cols.push({ "name": "sl_qnhantong", "label": "SL Q nhận tổng (KVARh)", "horizontalalignment": "right" });
    }
    if (dongcongto == "LANDIS") {
      cols.push({ "name": "ua", "label": "Điện áp Pha A", "horizontalalignment": "right" });
      cols.push({ "name": "ub", "label": "Điện áp Pha B", "horizontalalignment": "right" });
      cols.push({ "name": "uc", "label": "Điện áp Pha C", "horizontalalignment": "right" });
      cols.push({ "name": "ia", "label": "Dòng điện pha A", "horizontalalignment": "right" });
      cols.push({ "name": "ib", "label": "Dòng điện pha B", "horizontalalignment": "right" });
      cols.push({ "name": "ic", "label": "Dòng điện pha C", "horizontalalignment": "right" });
      cols.push({ "name": "i0", "label": "I0", "horizontalalignment": "right" });
      cols.push({ "name": "costb", "label": "Cos TB", "horizontalalignment": "right" });
    }
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAY_TSPT_KH" }),
      para: JSON.stringify({
        v_meterid: meterid,
        v_tungay: tungay,
        v_denngay: denngay,
        v_sotrang: 0,
        v_socongto: socongto,
        v_sodong: 10000,
        v_mataikhoan: mataikhoan,
        v_ip: "",
      }),
      title: title,
      header: header,
      filename: filename,
      sheets: "THÔNG SỐ PHỤ TẢI",
      columns: cols,
      data: ""
    };

    return this.api.downloadFile("api/ExportExcel", param, filename);
  }

  getChiSoCongToKH(danhmucid, loaihienthi, ngay, gio, loaipha, sotrang, sodong) {
    let curUs = this.user.getCurrentUser();
    let ip = sessionStorage.getItem(environment.IP_ADDRESS);
    var param = {
      config: JSON.stringify({ namesql: "PKG_THONGSOVANHANH.P_LAYDS_CHISOCTO" }),
      para: JSON.stringify({
        v_danhmucid: danhmucid,
        v_loaihienthi: loaihienthi,
        v_loaipha: loaipha,
        v_ngay: ngay,
        v_gio: gio,
        v_sotrang: sotrang,
        v_sodong: sodong,
        v_mataikhoan: curUs.mataikhoan,
        v_ip: ip,
      })
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
  getDsCongto(meterid) {
    var param = {
      "config": '{"namesql":"PKG_KHACHHANG.P_LAYDS_CONGTO"}',
      "para": '{"v_meterid":"' + meterid + '"}'
    };
    return this.api.Excute("api/ExcuteOracle", param);
  }
}



// WEBPACK FOOTER //
// /media/tranhien/34DCFEAFDCFE6B0E/SourceCode/AMISS4/AMISS4_PC1_LINUX/src/app/services/giam-sat/thong-so-phu-tai/tspt.service.ts